export default "__VITE_ASSET__CQuwaLPa__"